import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

interface ValidationInputProps {
  className?: string;
  value?: string | number | readonly string[];
  invalid?: boolean;
  disabled?: boolean;
  forwardedRef?: React.ForwardedRef<HTMLInputElement>;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

const ValidationInput: FunctionComponent<ValidationInputProps> = ({
  className,
  value,
  onChange,
  invalid,
  disabled,
  forwardedRef,
}) => {
  const getInputClassName = () => {
    if (value && invalid) {
      return `${className || ''} has-value invalid`;
    } else if (value) {
      return `${className || ''} has-value`;
    } else {
      return `${className || ''}`;
    }
  };
  return (
    <StyledInput
      className={getInputClassName()}
      value={value}
      maxLength={6}
      minLength={1}
      disabled={disabled}
      ref={forwardedRef}
      pattern="[0-9]*"
      required
      onChange={onChange}
    />
  );
};

export default ValidationInput;

const StyledInput = styled.input`
  font-size: 32px;
  font-weight: 700;
  width: 24px;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.differentBackground};
  border-bottom: 2px solid ${({ theme }) => theme.colors.tertiary};
  text-align: center;
  appearance: textfield;

  @media ${({ theme }) => theme.device.laptopL} {
    font-size: 40px;
    width: 40px;
  }

  transition: border
    ${({ theme }) => `${theme.transitions.duration} ${theme.transitions.type}`};

  &.has-value {
    border-bottom-color: ${({ theme }) => theme.colors.differentBackground};

    &.invalid {
      border-bottom-color: ${({ theme }) => theme.colors.error};
    }
  }
`;
